import { createFileRoute, Outlet } from "@tanstack/react-router"

import { usePanelStore } from "@/features/auth/panel-store"

/**
 * CNI panel layout. Bu route'a giren her child önce aktif paneli "cni" set eder
 * (deep-link, tarayıcı geri/ileri, doğrudan refresh için). `_authed.tsx` gate'i
 * yetki kontrolünü zaten yaptı; burada sadece state senkronizasyonu.
 */
export const Route = createFileRoute("/_authed/cni")({
  beforeLoad: () => {
    const panelStore = usePanelStore.getState()
    if (panelStore.active !== "cni") {
      panelStore.setActive("cni")
    }
  },
  component: CniLayout,
})

function CniLayout() {
  return <Outlet />
}
